import { render, staticRenderFns } from "./packVideo.vue?vue&type=template&id=2ddf546a&scoped=true&"
import script from "./packVideo.vue?vue&type=script&lang=js&"
export * from "./packVideo.vue?vue&type=script&lang=js&"
import style0 from "./packVideo.vue?vue&type=style&index=0&id=2ddf546a&lang=less&scoped=true&"
import style1 from "./packVideo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddf546a",
  null
  
)

component.options.__file = "packVideo.vue"
export default component.exports